import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch {
      setSettings({ whatsapp_number: "6282127656616", instagram_url: "#", tiktok_url: "#", shopee_url: "#" });
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const waLink = useCallback(
    (message) => {
      const number = (settings?.whatsapp_number || "6282127656616").replace(/[^0-9]/g, "");
      return `https://wa.me/${number}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
    },
    [settings]
  );

  return (
    <SettingsContext.Provider value={{ settings, waLink, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
